import IMask from 'imask';

const initForm = () => {
    // Ініціалізація масок для полів телефону
    const phoneInputs = document.querySelectorAll('input[type="tel"]');
    phoneInputs.forEach(function (input) {
        IMask(input, {
            mask: '+38 (000) 000 00 00',
            lazy: false,
            placeholderChar: '_'
        });
    });

    document.querySelectorAll('.wpcf7-submit').forEach(function (btn) {
        btn.addEventListener('click', function () {
            showLoadingIndicator();
        });
    });

    document.addEventListener('wpcf7mailsent', function (event) {
        hideLoadingIndicator();
    }, false);

    // Обробники подій Contact Form 7
    document.addEventListener('wpcf7mailfailed', function (event) {
        hideLoadingIndicator();
    }, false);

    document.addEventListener('wpcf7invalid', function (event) {
        hideLoadingIndicator();
    }, false);

    document.addEventListener('wpcf7spam', function (event) {
        hideLoadingIndicator();
    }, false);

    document.addEventListener('wpcf7aborted', function (event) {
        hideLoadingIndicator();
    }, false);

    function showLoadingIndicator() {
        document.querySelectorAll('.form-loader').forEach(function (loader) {
            loader.classList.add('active');
        });
    }

    function hideLoadingIndicator() {
        document.querySelectorAll('.form-loader').forEach(function (loader) {
            loader.classList.remove('active');
        });
    }
};

export default initForm;
